import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {useMemo} from 'react';
import {ShouldShowPasswordFormContext} from './context/should-show-password-form';
import {IsPasswordInvalidProvider} from './context/is-password-invalid';
import {View} from './view';
import {PasswordProvider} from './context/password';
import {PreviewMediaTypeProvider} from './context/preview-media-type';
import {NotificationProvider} from '@/components/unfixed-new-ui/notification';

export function PreviewPressReleasePage() {
  const client = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
          },
        },
      }),
    [],
  );

  return (
    <QueryClientProvider client={client}>
      <NotificationProvider>
        <PreviewMediaTypeProvider>
          <ShouldShowPasswordFormContext>
            <IsPasswordInvalidProvider>
              <PasswordProvider>
                <View />
              </PasswordProvider>
            </IsPasswordInvalidProvider>
          </ShouldShowPasswordFormContext>
        </PreviewMediaTypeProvider>
      </NotificationProvider>
    </QueryClientProvider>
  );
}
